import { API_ENDPOINTS } from "@/constants/endpoints";
import { ApiInterceptor } from "@/core/apiInterceptor";
import { AppConfig } from "@/config/env";
import { StatusCode } from "@/constants/statusCodes";
import type { ApiResponse, CommonAttributes } from "@/types/api";

export type UserProfileInfo = Record<string, unknown>;

interface UserProfilePayload extends CommonAttributes {
    data: {
        profile: {
            profile_info: UserProfileInfo;
        } | null;
    };
}

const userProfileApi = new ApiInterceptor({
    baseURL: AppConfig.apiBase,
    includeToken: true,
    module: "UserProfile",
}).service;

export const getUserDetailsApi = async (): Promise<UserProfileInfo> => {
    const response = await userProfileApi.post<ApiResponse<UserProfilePayload>>(
        API_ENDPOINTS.PROFILE.GETUSERPROFILE,
        { mode: "view" }
    );

    const body = response.data;
    const activityPayload = body?.responceDataObject;
    const result = activityPayload?.result;
    const message = activityPayload?.message || body?.message || "Failed to fetch user profile.";

    if (result !== StatusCode.Success) {
        throw new Error(message);
    }

    return activityPayload?.data?.profile?.profile_info ?? {};
};
